import Page from '../components/ui/Page';
import SampleTimeline from '../components/SampleTimeline';
import ContentLayout from '../layouts/ContentLayout';
import teamExample from '../utils/examples/team';

const IndexPage = () => {
  const examples = [teamExample];
  return (
    <Page>
      <ContentLayout fullWidth heading="Example Roadmap">
        <div>
          <div className="px-10">
            Read-only roadmap for ideas on how to use this. You can scroll around, but editing is
            disabled.
          </div>
          <div className="px-1 sm:px-10">
            {examples.map((example, i) => (
              <div key={`${example.id}-${i}`} className="my-32">
                <h4>{example.title}</h4>
                <div className="p-5 m-5 bg-white border rounded shadow-xl">
                  <SampleTimeline timeline={example} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </ContentLayout>
    </Page>
  );
};

export default IndexPage;
